import { motion } from "framer-motion";
import { CHAPTERS } from "./data";
import { Reveal } from "./Reveal";

const ChapterImage = ({ ch, onOpen }) => (
    <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="frame mt-10 overflow-hidden rounded-sm sm:mt-14"
    >
        <button
            type="button"
            data-testid={`${ch.id}-image`}
            className="chapter-img-btn"
            onClick={() => onOpen(ch)}
            aria-label={`Open larger view: ${ch.title} concept visual`}
        >
            <img
                src={ch.img}
                srcSet={`${ch.imgSm} 900w, ${ch.img} 1600w`}
                sizes="(max-width: 768px) 100vw, 1400px"
                alt={ch.alt}
                loading="lazy"
                className="w-full"
            />
        </button>
    </motion.div>
);

const Chapter = ({ ch, flip, onOpen }) => (
    <article data-testid={ch.id} className="py-16 sm:py-24">
        <Reveal>
            <div
                className={`flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between ${
                    flip ? "sm:flex-row-reverse" : ""
                }`}
            >
                <div className={`shrink-0 ${flip ? "sm:text-right" : ""}`}>
                    <p className="font-mono2 text-xs uppercase tracking-[0.22em] text-[#C7B7FF] sm:text-sm">
                        {ch.num} — {ch.title}
                    </p>
                    {ch.note && (
                        <p className="font-mono2 mt-3 max-w-xs text-[11px] uppercase leading-relaxed tracking-[0.16em] text-[#8A8580]">
                            {ch.note}
                        </p>
                    )}
                </div>
                <div className={`max-w-md ${flip ? "" : "sm:text-right"}`}>
                    <p className="text-base leading-relaxed text-[#C9C5C0] sm:text-lg">
                        {ch.copy}
                    </p>
                    {ch.serif && (
                        <p className="font-serif2 mt-5 text-xl italic leading-snug text-[#F4F1EC] sm:text-2xl">
                            {ch.serif}
                        </p>
                    )}
                </div>
            </div>
        </Reveal>
        <ChapterImage ch={ch} onOpen={onOpen} />
    </article>
);

export const Chapters = ({ onOpen }) => (
    <section
        id="how-it-works"
        data-testid="feature-chapters-container"
        className="px-5 sm:px-8"
    >
        <div className="mx-auto max-w-[1500px] border-t border-[#262422] pt-16 sm:pt-24">
            <Reveal>
                <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#8A8580]">
                    How it works — concept visuals · the product is still being designed
                </p>
            </Reveal>
            {CHAPTERS.map((ch, i) => (
                <Chapter key={ch.id} ch={ch} flip={i % 2 === 1} onOpen={onOpen} />
            ))}
        </div>
    </section>
);
